import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';
import {CouponCode, CouponCodeInput} from '../__generated__/resolvers-types';
import validateRequestError from '../util/error/validateRequestError';

export const CREATE_COUPON_CODE_MUTATION = gql`
  mutation CreateCouponCode($input: CouponCodeInput!) {
    createCouponCode(input: $input) {
      id
      name
      status
      maxUses
      usedCount
      createdAt
      expiryDate
      durationDays
      couponRole
      createdBy
    }
  }
`;

export const useCreateCouponCode = () => {
  const [createCouponCode] = useMutation<{createCouponCode: CouponCode}>(CREATE_COUPON_CODE_MUTATION);

  const createCoupon = async (input: CouponCodeInput) => {
    const result = await validateRequestError(createCouponCode({variables: {input}}));
    return result?.createCouponCode;
  };

  return createCoupon;
};
